import * as i0 from '@angular/core';
import * as i1 from './list.module';
import * as i2 from './list.component';
import * as i3 from './list-page-tracker.directive';
import * as i4 from './infinite-list.directive';
export const ElListModuleNgFactory:i0.NgModuleFactory<i1.ElListModule> = (null as any);
var _decl0_0:i2.ElListComponent = (<any>(null as any));
var _decl0_1:i2.ElListItemComponent = (<any>(null as any));
var _decl0_2:i3.ElListPageTrackerDirective = (<any>(null as any));
var _decl0_3:i4.ElInfiniteListDirective = (<any>(null as any));
var _decl0_4:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_5:i0.ElementRef<any> = (<any>(null as any));
function _View_ElListComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_0.role;
  currVal_0;
}
function _View_ElListComponent_1_0():void {
  var _any:any = (null as any);
}
function _View_ElListItemComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_1.role;
  currVal_0;
}
function _View_ElListItemComponent_2_0():void {
  var _any:any = (null as any);
}
